import axios from 'axios';
import router from '../router'
import { EventBus } from '../main'
import Vue from 'vue'
import store from '../store'

export default {
    data: {
        config: {}
    },
    methods: {
        /*
        * GET PRODUCTS
        */
        async getProducts(companyId, config) {
            this.config = config;
            EventBus.$emit('show-loading', true);
            return await axios
                .get('products/' + companyId, this.config)
                .then(response => {
                    EventBus.$emit('show-loading', false);
                    return response.data
                })
                .catch(error => {
                    EventBus.$emit('show-loading', false);
                    Vue.prototype.$generalAPIErrorHandling(error, router);
                })
        }
    }
}
